export class LeadStatus {
  public readonly unique_id!: string;
  public readonly lead_status!: string;
  public approved_loan_amount?: number | null;
}

export const LeadStatusValues: Record<string, string> = {
  not_defined: '0',
  under_review: '1',
  further_information_required: '2',
  prospective_client: '3',
  on_hold: '4',
  declined: '5',
  not_currently_pursuing: '6',
  active_client: '7',
  request_lead_contact: '8',
  active_funded: '9',
  active_funded_grant: '10',
  active_technical_assistance: '11',
};
